import { render, staticRenderFns } from "./body.vue?vue&type=template&id=7045eab3&scoped=true"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7045eab3",
  null
  
)

export default component.exports